export default "__VITE_ASSET__e1a4618a__"